<div class="card card-cascade h-100">
    <div class="view gradient-card-header secondary-gradient white-text">
        <h3 class='h3-responsive text-center'>{{item.title}}</h3>
    </div>
    <div class="card-body pt-1 pt-md-3">
        <div class="row justify-content-center">
            <app-summary-scales-chart class="col chart" *ngIf="item.type=='SummaryScalesChart'" 
            [ngClass]="getClasses(item)"
            [showNames]="item.data.showNames" 
            [chartScaleNames]="item.data.chartScaleNames"
            [chartRangeNames]="item.data.chartRangeNames"
            [showRangeScore]="item.data.showRangeScore"
            [scaleResults]="scaleResults"
            [reverseDirection]="item.data.reverseDirection"></app-summary-scales-chart>
            <app-pcl-summary *ngIf="item.type=='PCLSummary'" class="col summary-main p-small-chart" [assessmentResult]="assessmentResult"
                [summaryScaleResult]="PCLSummaryScaleResult"></app-pcl-summary>
        </div>
        <hr *ngIf="item.data.showRangeLabel" class="d-print-none" />
        <div class="row justify-content-center" *ngIf="item.data.showRangeLabel">
            <h4>Severity: <strong>{{getRangeNameForFirstScaleResult(scaleResults)}}</strong></h4>
        </div>
    </div>
</div>


// WEBPACK FOOTER //
// ./src/app/reports/report-items/summary-section-graph-item/summary-section-graph-item.component.html